export default __webpack_public_path__ + "static/media/waveform-playing.5a700b86.svg";